import { ServiceAssignment } from '../types';

/**
 * Anzeigename einer LV-Zuordnung — EINE Stelle statt fuenf handgeschriebener
 * Ketten im Cockpit (AdminDashboard). Die Ketten kannten 'flatrate' nicht
 * und zeigten die Monatspauschale als rohes „flatrate", zwei von ihnen
 * kannten auch Planung und Bauordnung nicht.
 *
 * 'lang' fuer Filter und Ueberschriften („Begehungen", „Zusatzleistungen"),
 * 'kurz' fuer Tabellenzellen („Begehung", „Zusatz", „Vorank.").
 * Unbekannte Werte kommen roh zurueck, damit ein neuer Wert auffaellt statt
 * unter „Sonstige" zu verschwinden.
 */
const LANG: Record<ServiceAssignment, string> = {
    inspection: 'Begehungen',
    vorank: 'Vorankündigung',
    sigeplan: 'SiGe-Plan',
    asplan: 'A+S-Plan',
    einweisung: 'Einweisung SiGe-Plan',
    unterlage: 'Unterlage',
    additional: 'Zusatzleistungen',
    planning_general: 'Planung',
    site_rules: 'Bauordnung',
    flatrate: 'Monatspauschale',
    unterweisung: 'Unterweisungen',
    gbu: 'Gefährdungsbeurteilung (SiFa)',
    none: 'Sonstige',
};

const KURZ: Record<ServiceAssignment, string> = {
    inspection: 'Begehung',
    vorank: 'Vorank.',
    sigeplan: 'SiGe-Plan',
    asplan: 'A+S-Plan',
    einweisung: 'Einweisung',
    unterlage: 'Unterlage',
    additional: 'Zusatz',
    planning_general: 'Planung',
    site_rules: 'Bauordnung',
    flatrate: 'Monatspauschale',
    unterweisung: 'Unterweisung',
    gbu: 'GBU',
    none: 'Sonstige',
};

export const assignmentLabel = (assignment: string | null | undefined, form: 'lang' | 'kurz' = 'kurz'): string => {
    if (!assignment) return '—';
    const map = form === 'lang' ? LANG : KURZ;
    return (map as Record<string, string>)[assignment] ?? assignment;
};
